import { render, staticRenderFns } from "./KeybeAvatar.vue?vue&type=template&id=6add788c&scoped=true&"
import script from "./KeybeAvatar.vue?vue&type=script&lang=js&"
export * from "./KeybeAvatar.vue?vue&type=script&lang=js&"
import style0 from "./KeybeAvatar.vue?vue&type=style&index=0&id=6add788c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6add788c",
  null
  
)

export default component.exports